import { Radio, RadioGroup } from '@grupoboticario/flora-react';
import { fixedCards } from 'utils/openClaimRequiredDocs';

import { ReactComponent as PositiveIcon } from 'assets/images/positiveIcon.svg';
import { ReactComponent as NegativeIcon } from 'assets/images/negativeIcon.svg';
import { PencilIcon } from '@grupoboticario/flora-react-icons';
import { CardInfo } from '../../sharedStyles';

import {
  CardInfoTitleSummary,
  EditButton,
  CardInfoDocDeclaration,
  CardInfoDocDeclarationRadio,
  CardInfoDocDeclarationRadioText,
  CardInfoDocWrapper,
  CardInfoDoc,
} from '../styles';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card07 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  const documents = stateClaim.step.step1?.tipos?.data?.documents;
  const files = stateClaim.step.step4?.files;
  const state = stateClaim.step.step4?.state;

  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Documentação
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(4)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <CardInfoDocDeclaration>
        <div className="info">
          <PositiveIcon />
          <span className="title">
            Declaração de inexistência de outros seguros<span>*</span>
          </span>
          <RadioGroup value="no">
            {/* Valor do radio eh mockado, apenas para visualizacao */}
            <CardInfoDocDeclarationRadio>
              <Radio id="no" value="no" size="small" />
              <CardInfoDocDeclarationRadioText as="label" htmlFor="no">
                {state?.declarationRadio === 'yes' && (
                  <>
                    Declaro que existe(m) outra(s) apólice(s) de seguro que
                    conceda(m) cobertura(s) ao(s) mesmo(s) bem(ns) amparado(s)
                    pela apólice
                  </>
                )}
                {state?.declarationRadio === 'no' && (
                  <>
                    Declaro que não existe outra apólice de seguros que conceda
                    cobertura ao(s) mesmo(s) bem(ns) amparado(s) pela apólice
                    mencionada.
                  </>
                )}
              </CardInfoDocDeclarationRadioText>
            </CardInfoDocDeclarationRadio>
          </RadioGroup>
        </div>
        {state?.declarationRadio === 'yes' && (
          <>
            <hr />
            <div className="files">
              {files
                ?.filter(
                  (file: any) =>
                    file.documentId ===
                    documents?.find((doc: any) => doc.name === fixedCards[0])
                      .id,
                )
                .map((file: any) => (
                  <p key={file.id}>{file.filename}</p>
                ))}
            </div>
          </>
        )}
        {state?.declarationRadio === 'no' && (
          <div className="filesPlaceholder" />
        )}
      </CardInfoDocDeclaration>
      <CardInfoDocWrapper>
        {fixedCards.slice(1).map((card: string) => {
          const fileList = files?.filter(
            (file: any) =>
              file.documentId ===
              documents?.find((doc: any) => doc.name === card).id,
          );
          return (
            <CardInfoDoc
              key={documents?.find((doc: any) => doc.name === card).id}
            >
              <div className="info">
                {fileList?.length > 0 ? <PositiveIcon /> : <NegativeIcon />}
                <span className="title">
                  {card}
                  <span>*</span>
                </span>
              </div>
              <hr />
              <div className="files">
                {fileList?.map((file: any) => (
                  <p key={file.id}>{file.filename}</p>
                ))}
              </div>
            </CardInfoDoc>
          );
        })}

        {documents &&
          stateClaim.draftId &&
          documents
            .filter(
              (doc: any) => !fixedCards.find((card: any) => card === doc.name),
            )
            ?.map((doc: any) => {
              const fileList = files?.filter(
                (file: any) => file.documentId === doc.id,
              );
              return (
                <CardInfoDoc key={doc.id}>
                  <div className="info">
                    {fileList?.length > 0 ? <PositiveIcon /> : <NegativeIcon />}
                    <span className="title">
                      {doc.name}
                      <span>{doc.mandatory ? '*' : ''}</span>
                    </span>
                  </div>
                  <hr />
                  <div className="files">
                    {fileList?.map((file: any) => (
                      <p key={file.id}>{file.filename}</p>
                    ))}
                  </div>
                </CardInfoDoc>
              );
            })}
      </CardInfoDocWrapper>
    </CardInfo>
  );
};
